import styled from 'styled-components';

export const ButtonContainer = styled.div`
  justify-self: end;

  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-self: center;
  }
`;
